import { defineComponent as H, ref as S, shallowRef as w, computed as A, watch as f, onMounted as b, onUnmounted as E, openBlock as C, createElementBlock as D, normalizeStyle as k } from "vue";
import B from "lottie-web/build/player/lottie_light.min.js";
import { fetchLottie as _ } from "@reslear/dotlottie-player-core";
import './assets/index.css';function V(a) {
  try {
    if (!a || typeof a != "string" && typeof a != "object" || Array.isArray(a))
      return;
    if (typeof a == "object")
      return JSON.parse(JSON.stringify(a));
    const r = JSON.parse(a);
    if (typeof r == "object")
      return r;
  } catch {
  }
}
const j = /* @__PURE__ */ H({
  __name: "vue3-lottie",
  props: {
    animationData: { default: "" },
    animationLink: { default: "" },
    loop: { type: [Boolean, Number], default: !0 },
    autoPlay: { type: Boolean, default: !0 },
    renderer: { default: "svg" },
    rendererSettings: { default: null },
    width: { default: "100%" },
    height: { default: "100%" },
    speed: { default: 1 },
    delay: { default: 0 },
    direction: { default: "forward" },
    pauseOnHover: { type: Boolean, default: !1 },
    playOnHover: { type: Boolean, default: !1 },
    backgroundColor: { default: "transparent" },
    pauseAnimation: { type: Boolean, default: !1 },
    fetchOptions: { default: void 0 },
    onLoopComplete: {},
    onEnterFrame: {},
    onSegmentStart: {},
    onComplete: {},
    onAnimationLoaded: {}
  },
  emits: ["complete", "loop-complete", "enter-frame", "segment-start", "animation-loaded"],
  setup(a, { emit: r }) {
    const e = a, l = r;
    let t = null;
    const s = S(null);
    let p = 1;
    const u = w(null), d = async (n) => {
      let o = e.autoPlay;
      e.playOnHover && (o = !1);
      let i = e.loop;
      typeof i == "number" && i > 0 && (i = i - 1), e.delay > 0 && (o = !1);
      const L = {
        container: n,
        renderer: e.renderer,
        rendererSettings: e.rendererSettings,
        loop: i,
        autoplay: o,
        animationData: u.value
      };
      t = B.loadAnimation(L), t && (setTimeout(() => {
        t && (o = e.autoPlay, e.playOnHover ? t.pause() : o ? t.play() : t.pause(), e.onAnimationLoaded && l("animation-loaded"));
      }, e.delay), t.setSpeed(e.speed), e.direction === "reverse" && t.setDirection(-1), e.direction === "normal" && t.setDirection(1), (e.pauseAnimation || e.playOnHover) && t.pause(), c());
    };
    function c() {
      t && (e.onLoopComplete && t.addEventListener("loopComplete", () => {
        t && (e.direction === "alternate" && (t.stop(), p = p === -1 ? 1 : -1, t.setDirection(p), t.play()), l("loop-complete"));
      }), e.onComplete && t.addEventListener("complete", () => {
        l("complete");
      }), e.onEnterFrame && t.addEventListener("enterFrame", () => {
        l("enter-frame");
      }), e.onSegmentStart && t.addEventListener("segmentStart", () => {
        l("segment-start");
      }));
    }
    const y = A(() => {
      let n = e.width, o = e.height;
      return typeof e.width == "number" && (n = `${e.width}px`), typeof e.height == "number" && (o = `${e.height}px`), {
        "--lottie-animation-container-width": n,
        "--lottie-animation-container-height": o,
        "--lottie-animation-container-background-color": e.backgroundColor
      };
    }), h = () => {
      t && e.pauseOnHover && t.pause(), t && e.playOnHover && t.play();
    }, v = () => {
      t && e.pauseOnHover && t.play(), t && e.playOnHover && t.pause();
    };
    f(
      () => e.pauseAnimation,
      () => {
        if ((e.pauseOnHover || e.playOnHover) && e.pauseAnimation) {
          console.error(
            "If you are using pauseAnimation prop for Vue3-Lottie, please remove the props pauseOnHover and playOnHover"
          );
          return;
        }
        t && (e.pauseAnimation ? t.pause() : t.play());
      }
    );
    const m = () => {
      t && (t.destroy(), t = null);
    }, g = () => {
      if (e.pauseOnHover && e.playOnHover)
        throw new Error(
          "You cannot set pauseOnHover and playOnHover for Vue3-Lottie at the same time."
        );
      s.value && d(s.value);
    };
    async function O({
      data: n,
      link: o
    }) {
      const i = n ? V(n) : await _(o, e.fetchOptions);
      if (!i)
        throw new Error("You must provide correct animationLink or animationData");
      u.value = i;
    }
    return f(
      () => [e.animationData, e.animationLink],
      ([n, o]) => {
        O({ link: o, data: n });
      },
      {
        immediate: !0
      }
    ), b(() => {
      f(
        () => u.value,
        (n, o) => {
          n && n !== o && (m(), g());
        },
        {
          immediate: !0
        }
      );
    }), E(() => {
      m();
    }), (n, o) => (C(), D("div", {
      ref_key: "root",
      ref: s,
      class: "lottie-animation-container",
      style: k(y.value),
      onMouseenter: h,
      onMouseleave: v
    }, null, 36));
  }
}), F = {
  install(a, r) {
    const e = (r == null ? void 0 : r.name) ?? "Vue3Lottie";
    a.component(e, j);
  }
};
export {
  j as Vue3Lottie,
  F as default
};
